import { ComposeViewState } from 'owa-mail-compose-store';
import { action } from 'satcheljs';

export default action(
    'onInlineComposeSendStateChange',
    (viewState: ComposeViewState, isSendPending: boolean) => ({
        viewState,
        isSendPending,
    })
);
